export default "__VITE_ASSET__Bn83nAFQ__"